import Vue from 'vue';

import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  configure,
} from 'vee-validate';
import {
  required,
  email,
  min,
  confirmed,
  regex,
} from 'vee-validate/dist/rules';
import de from 'vee-validate/dist/locale/de.json';

Vue.component('mj-validation-observer', ValidationObserver);
Vue.component('mj-validation-provider', ValidationProvider);

extend('email', email);
extend('required', required);
extend('min', min);
extend('confirmed', confirmed);
extend('regex', regex);

localize({
  de: {
    messages: de.messages,
    names: {
      name: 'Name',
      email: 'E-Mail',
      password: 'Passwort',
      password_confirmation: 'Passwort bestätigen',
      new_password: 'Neues Passwort',
      new_password_confirmation: 'Neues Passwort bestätigen',
      eventname: 'Eventname',
      eventdate: 'Datum',
      date: 'Datum',
      register_code: 'Registriercode',
    },
  },
});

localize('de');

configure({
  useConstraintAttrs: false,
});
